import { render, staticRenderFns } from "./EditFeePreferences.vue?vue&type=template&id=f86884b0"
import script from "./EditFeePreferences.vue?vue&type=script&lang=js"
export * from "./EditFeePreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports